import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "../Modal/Modal";
import CTE from "../Constants";

function ItemsCarouselWidget(props) {
    const [texts, setTexts] = useState({
        title: "Items",
        send: "Acept",
        cancel: "Cancel",
    });

    const tabKeyIdxMap = {
        menu: 0,
        order: 1,
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [tabIdx, setTabIdx] = useState(0);

    const [currentItem, setCurrentItem] = useState({});
    const [currentItemIndex, setCurrentItemIndex] = useState(0);

    const [selectedItems, setSelectedItems] = useState([]);
    const [orderCurrentItem, setOrderCurrentItem] = useState({});
    const [orderCurrentItemIndex, setOrderCurrentItemIndex] = useState(0);

    const closeModal = function () {
        setIsModalOpen(false);
    };

    const sendSelectedItems = function () {
        props.interactionCb(CTE.CONTENT_TYPE.ITEMS_CAROUSEL_MESSAGE, selectedItems);
        setIsModalOpen(false);
    };

    const handleTabChange = function (newTabIdx) {
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(tabKeyIdxMap)) {
            if (newTabIdx === value) {
                setTabIdx(newTabIdx);
                break;
            }
        }
    };

    // ***************************************************
    // Manage the state of all the items of the menu
    // ***************************************************

    const setNextItem = function () {
        if (currentItemIndex < props.options.length - 1) {
            setCurrentItem(props.options[currentItemIndex + 1]);
            setCurrentItemIndex(currentItemIndex + 1);
        }
    };

    const setPrevItem = function () {
        if (currentItemIndex > 0) {
            setCurrentItem(props.options[currentItemIndex - 1]);
            setCurrentItemIndex(currentItemIndex - 1);
        }
    };

    const addItem = function () {
        // get the index of the current element
        let index = currentItemIndex;
        // update the list of the order
        setSelectedItems([...selectedItems, props.options[index]]);
        // update the current element of the order
        if (selectedItems.length === 0) {
            setOrderCurrentItem(props.options[index]);
            setOrderCurrentItemIndex(0);
        }
    };

    // ***************************************************
    // Manage the state of of the customer's order
    // ***************************************************

    const orderSetNextItem = function () {
        let index = orderCurrentItemIndex;
        if (index < selectedItems.length - 1) {
            index += 1;
            setOrderCurrentItem(selectedItems[index]);
            setOrderCurrentItemIndex(index);
        }
    };

    const orderSetPrevItem = function () {
        let index = orderCurrentItemIndex;
        if (index > 0) {
            index -= 1;
            setOrderCurrentItem(selectedItems[index]);
            setOrderCurrentItemIndex(index);
        }
    };

    const orderRemoveItem = function () {
        // TODO implement
    };

    useEffect(() => {
        // set texts based on languages
        if (props.language === "SPANISH") {
            setTexts({
                title: "Items",
                send: "Aceptar",
                cancel: "Cancelar",
            });
        }
        setCurrentItemIndex(0);
        setCurrentItem(props.options[0]);
        // eslint-disable-next-line
    }, []);

    return (
        <div className="opt-items-carousel-widget">
            <Modal
                show={isModalOpen}
                acceptCb={sendSelectedItems}
                closeCb={closeModal}
                acceptText={texts.send}
                cancelText={texts.cancel}
                disabled={false}
            >
                <Tabs selectedIndex={tabIdx} onSelect={(newTabIdx) => handleTabChange(newTabIdx)}>
                    <TabList>
                        <Tab>Menu</Tab>
                        <Tab>My Order ({selectedItems.length})</Tab>
                    </TabList>

                    <TabPanel className="opt-app__tab--reco">
                        <div className="opt-items-carousel-widget__modal-content">
                            <div className="opt-items-carousel-widget__item-content">
                                <div className="opt-row">
                                    <div className="opt-col">
                                        <label className="opt-items-carousel-widget__input-container">
                                            <input
                                                placeholder="Search items"
                                                className="chat-bar__input"
                                                type="text"
                                            />
                                        </label>
                                    </div>
                                </div>
                                {/* <h2></h2> */}
                                <div className="opt-row">
                                    <div className="opt-col opt-text-center">
                                        <div className="opt-items-carousel-widget__title-container">
                                            <p>
                                                <span className="opt-items-carousel-widget-item-title">
                                                    {currentItem.elementTitle + "    "}
                                                </span>
                                            </p>
                                            <p>
                                                <span className="opt-items-carousel-widget-item-price">
                                                    {currentItem.subtitle}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="opt-row">
                                    <div className="opt-col">
                                        <img
                                            className="opt-items-carousel-widget__img"
                                            src={props.baseUrl + currentItem.imageUrl}
                                            alt="preview for your custom response"
                                        />
                                    </div>
                                </div>
                                <div className="opt-row opt-row--space-around opt-items-carousel-widget__items-controls-container">
                                    <button
                                        className="opt-button opt-button--light opt-items-carousel-widget__items-controls-button-left"
                                        onClick={() => setPrevItem()}
                                    >
                                        Prev
                                    </button>
                                    <button
                                        className="opt-button opt-items-carousel-widget__items-controls-button-left"
                                        onClick={() => addItem()}
                                    >
                                        Add
                                    </button>
                                    <button
                                        className="opt-button opt-button--light opt-items-carousel-widget__items-controls-button-right"
                                        onClick={() => setNextItem()}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel className="opt-app__tab--reco">
                        {selectedItems.length === 0 && (
                            <p>Your order is empty, please select items from the Menu</p>
                        )}
                        {selectedItems.length > 0 && (
                            <div className="opt-items-carousel-widget__modal-content">
                                <div className="opt-row">
                                    <div className="opt-col">
                                        <div className="opt-items-carousel-widget__title-container">
                                            <p>
                                                <span className="opt-items-carousel-widget-item-title">
                                                    {orderCurrentItem.elementTitle + "    "}
                                                </span>
                                            </p>
                                            <p>
                                                <span className="opt-items-carousel-widget-item-price">
                                                    {orderCurrentItem.subtitle}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="opt-row">
                                    <div className="opt-col">
                                        <img
                                            className="opt-items-carousel-widget__img"
                                            src={props.baseUrl + orderCurrentItem.imageUrl}
                                            alt="preview for your custom response"
                                        />
                                    </div>
                                </div>
                                <div className="opt-row opt-row--space-around opt-items-carousel-widget__items-controls-container">
                                    <button
                                        className="opt-button opt-button--light opt-items-carousel-widget__items-controls-button-left"
                                        onClick={() => orderSetPrevItem()}
                                    >
                                        Prev
                                    </button>

                                    <button
                                        className="opt-button opt-items-carousel-widget__items-controls-button-right"
                                        onClick={() => orderRemoveItem()}
                                    >
                                        Remove
                                    </button>

                                    <button
                                        className="opt-button opt-button--light opt-items-carousel-widget__items-controls-button-right"
                                        onClick={() => orderSetNextItem()}
                                    >
                                        Next
                                    </button>
                                </div>
                                {/* <div className="opt-items-carousel-widget__items-controls">
                                </div> */}
                            </div>
                        )}
                    </TabPanel>
                </Tabs>
            </Modal>
            <span
                className="opt-items-carousel-widget__text"
                onClick={() => setIsModalOpen(!isModalOpen)}
            >
                {" "}
                {props.label}
            </span>
        </div>
    );
}
export default ItemsCarouselWidget;
